// app/frontend/pages/Onboarding/steps/StepSkillLevel.tsx
import { Stack, Radio, Group, Box } from "@mantine/core";
import { IconStar, IconStarFilled, IconStarHalfFilled } from "@tabler/icons-react";
import { StepShell } from "../../../components/ui/Stepper";
import { L2KText } from "../../../components/ui/Typography";
import type { StepComponentProps } from "../../../components/ui/Stepper";
import type { OnboardingFormValues } from "../types";

const skillLevels = [
  {
    value: "beginner",
    label: "Beginner",
    description: "I'm just starting my dance journey",
    icon: IconStar,
  },
  {
    value: "intermediate",
    label: "Intermediate",
    description: "I know the basics and want to improve",
    icon: IconStarHalfFilled,
  },
  {
    value: "advanced",
    label: "Advanced",
    description: "I'm experienced and looking to refine my skills",
    icon: IconStarFilled,
  },
];

export function StepSkillLevel({ form }: StepComponentProps<OnboardingFormValues>) {
  return (
    <StepShell
      title="What's your skill level?"
      subtitle="This helps us recommend the right content for you"
    >
      <Radio.Group
        value={form.values.skill_level}
        onChange={(value) => form.setFieldValue("skill_level", value)}
      >
        <Stack gap="md">
          {skillLevels.map((level) => (
            <Box
              key={level.value}
              onClick={() => form.setFieldValue("skill_level", level.value)}
              style={{
                padding: "16px",
                borderRadius: "12px",
                border: `2px solid ${
                  form.values.skill_level === level.value
                    ? "#FF9800"
                    : "rgba(255, 152, 0, 0.2)"
                }`,
                backgroundColor:
                  form.values.skill_level === level.value
                    ? "rgba(255, 152, 0, 0.1)"
                    : "rgba(255, 255, 255, 0.02)",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
            >
              <Group gap="md" wrap="nowrap">
                <Box
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: "10px",
                    background:
                      form.values.skill_level === level.value
                        ? "linear-gradient(135deg, #FF9800, #FF5722)"
                        : "rgba(255, 152, 0, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <level.icon
                    size={24}
                    color={form.values.skill_level === level.value ? "#fff" : "#FF9800"}
                  />
                </Box>
                <Stack gap={4} style={{ flex: 1 }}>
                  <Group gap="sm">
                    <Radio
                      value={level.value}
                      label=""
                      styles={{
                        radio: {
                          backgroundColor: "transparent",
                          borderColor:
                            form.values.skill_level === level.value
                              ? "#FF9800"
                              : "rgba(255, 152, 0, 0.4)",
                          "&:checked": {
                            backgroundColor: "#FF9800",
                            borderColor: "#FF9800",
                          },
                        },
                      }}
                    />
                    <L2KText fw={600}>{level.label}</L2KText>
                  </Group>
                  <L2KText variant="secondary" size="sm">
                    {level.description}
                  </L2KText>
                </Stack>
              </Group>
            </Box>
          ))}
        </Stack>
      </Radio.Group>
    </StepShell>
  );
}

export default StepSkillLevel;
